export const CUSTOM_REQUESTS_TYPES = {
  timeoff_leave: 'timeoff_leave_approvals',
  expense_expense: 'expenses_expense_approvals',
  expenses_mileage: 'expenses_mileage_approvals',
  expenses_expensable: 'expenses_expensable_approvals',
  ats_requisition: 'ats_requisition_approvals',
  ended_hiring_in_unterminated_employees: 'ended_hiring_in_unterminated_employees',
  pending_enps: 'pending_question_group_enps',
  expenses_card: 'expenses_card_approvals',
  purchase_request_approvals: 'purchase_request_approvals',
  training_request_approvals: 'training_request_approvals',
  attendance_edit_timesheet_request_approvals: 'attendance_edit_timesheet_request_approvals',
  banking_card: 'pending_banking_cards',
  swap_shift_request_approvals: 'swap_shift_request_approvals',
}
